<template>
    <div class="ps-page--404">
        <div class="container">
            <div class="ps-section__content"><img src="../assets/img/checked_im.png" width="20%" alt="">
                <h3 v-if="isEnglish()==true">Thank You!</h3> <br/>
                <h3 v-if="isEnglish()==false">Merci !</h3> <br/>
                <p  v-if="isEnglish()==true">We have successfully received your request.<a href="/#/products"> Go to products</a></p> <br/> <br/>             
                <p  v-if="isEnglish()==false">Nous avons bien reçu votre demande.<a href="/#/products"> Voir les produits</a></p> <br/> <br/>
            </div>
        </div>
    </div>
            
</template>



<script>
export default {
  name: 'OrderSuccess',
  props: ['orderState'],
  data () {
    
    return {
      msg:'Welcome to Your Vue.js App',
      caller_role:localStorage.getItem('caller_role'),
      orderState_:this.orderState,
      token:localStorage.getItem('token'),
   
    }
  },

  methods:{
    isEnglish(){
          let lang = localStorage.getItem('lang');
          if(lang=='en'){

          return true;

          }else if(lang=='fr'){

          return false;

          }else{

          return true;

          }


    }
  },

    watch: {

 
    },


    mounted(){

   

    },

    created(){
     
      if(localStorage.getItem('token')=='' || localStorage.getItem('token')==null){

        this.$router.push('/login');

      }else{

      
          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');
          

      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrderSuccess.vue